import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-gs-first-component',
	templateUrl:'./FirstComponentPage.html',
	styles: [],
	styleUrls:['./FirstComponentPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FirstComponentPage
{
	mdContent_37 = `\`\`\`java
@NgComponent("my-home")
@NgRoutable(path = "")
public class MyHomePage extends DivSimple<MyHomePage>
        implements INgComponent<MyHomePage> {

    public MyHomePage() {
        var card = new WaCard<>();
        card.add("Welcome to JWebMP!");
        add(card);

        var button = new WaButton<>("Click Me", Variant.Brand);
        add(button);
    }
}
\`\`\``;
}
